import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { smsHistory } from "../../../store/actions";
import { useParams } from "react-router-dom";
import moment from "moment";

const SMSHistory = () => {
  const dispatch = useDispatch();
  const { editId } = useParams();
  const adminId = localStorage && localStorage.getItem("id");
  const messages = useSelector((s) => s?.Customers?.SmsHistory?.data);

  useEffect(() => {
    if (adminId && editId) {
      dispatch(smsHistory({ sender_id: adminId, receiver_id: editId }));
    }
  }, [adminId, editId]);
  return (
    <>
      <section className="messge-history p-5">
        <Container>
          <Row>
            {(messages &&
              messages.length > 0 &&
              messages.map((item, idx) => {
                return (
                  <Col md={12} key={idx}>
                    <div className="messge-detail-box">
                      <div className="messge-detail-date d-flex justify-content-between">
                        <span className="msg-date text-start">
                          Send by:- {item.sender_name}
                        </span>
                        <span className="msg-date">
                          {moment(item.created_at).format("DD/MM/YYYY HH:MM A")}
                        </span>
                      </div>
                      <p>{idx + 1 + ". " + item.sms_content}</p>
                    </div>
                  </Col>
                );
              })) || (
              <Col md={12}>
                <div className="messge-detail-box">
                  <p className="text-center">No Messages!</p>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SMSHistory;
